var { location } = window;
var stripeKey = (location.hostname.indexOf('localhost') >= 0 || location.hostname.indexOf('test.skinova') >= 0)? 'pk_test_qvncEyELDRrBpL0cp9uNuONy00jvqc0hR8' : 'pk_live_nxkJQ8hSDUcol3SVjkHXRgWn007r9n2Yie';
export default {
    'stripeKey': stripeKey,
    "siteURL": `${location.protocol}//${location.hostname}${location.port? `:${location.port}`: ''}`,
    "propertySearchPaging": 10
}